import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeSelectOption from '@s-ui/react-molecule-dropdown-option'
import MoleculeSelect, {moleculeSelectDropdownListSizes} from '@s-ui/react-molecule-select'
import ChevronDown from '@adv-mt/mt-svg-icons/lib/ChevronDown'

const BASE_CLASS = 'mt-HeroDealersList-selector'
const BUTTON_CLASS = `${BASE_CLASS}Button`

const HeroDealersListSelector = ({onProvinceSelected = () => {}}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const provinces = config.get('provinces')

  const [selectedProvinceId, setSelectedProvinceId] = useState()

  const handleChange = (ev, {value}) => {
    ev.preventDefault()
    setSelectedProvinceId(value)
  }

  const handleClick = () => {
    onProvinceSelected({provinceId: selectedProvinceId})
  }

  return (
    <div className={BASE_CLASS}>
      <MoleculeSelect
        onChange={handleChange}
        iconArrowDown={<ChevronDown size={ATOM_ICON_SIZES.medium} />}
        size={moleculeSelectDropdownListSizes.SMALL}
        placeholder={i18n.t('HERO_DEALERS_LIST_SELECT_PLACEHOLDER')}
        value={selectedProvinceId}
      >
        {provinces.map(({id, label}, index) => (
          <MoleculeSelectOption key={id} value={id}>
            {label}
          </MoleculeSelectOption>
        ))}
      </MoleculeSelect>
      <div className={BUTTON_CLASS}>
        <AtomButton
          color="accent"
          onClick={handleClick}
          shape={atomButtonShapes.CIRCULAR}
          size={atomButtonSizes.MEDIUM}
        >
          {i18n.t('HERO_DEALERS_LIST_BUTTON_TEXT')}
        </AtomButton>
      </div>
    </div>
  )
}

HeroDealersListSelector.propTypes = {
  onProvinceSelected: PropTypes.func
}

export default HeroDealersListSelector
